import React, { useEffect, useReducer, useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import styles from "./index.module.scss";
import btnBg from "../../assets/images/btnBg.png";
import { useNavigate } from "react-router";
import axios from "axios";
import useCart from "../../customHooks/useCart";

const inputs = [
  {
    label: "Enter your name",
    name: "name",
    className: "form-control",
    type: "text",
    placeholder: "Enter your name",
    required: true,
  },
  {
    label: "Enter your email",
    name: "email",
    className: "form-control",
    type: "email",
    placeholder: "Enter your email",
    required: true,
  },
  {
    label: "I Accept",
    name: "policy",
    className: "form-control",
    type: "checkbox",
    required: true
  }
];
const defaultErr = {
  name: "",
  email: "",
  policy: false
};

const initialState = {
  isLoading: false,
  name: "",
  email: "",
  policy: false,
  errors: {
    ...defaultErr,
  },
};

const Action_Type = {
  handleInputChange: "handleInputChange",
  handleError: "handleError",
  loading: "loading",
  resetState: "resetState"
};

const sendEmailURL =
  "https://asia-south1-penfold-e4a29.cloudfunctions.net/sendEmail";

const reducer = (state, action) => {
  let { type, payload } = action;

  switch (type) {
    case Action_Type.handleInputChange:
      return { ...state, [payload.name]: payload.value };
      case Action_Type.handleCheck:
      return { ...state, [payload.name]: payload.value };
    case Action_Type.handleError:
    case Action_Type.loading:
      return { ...state, ...payload };
      case Action_Type.resetState:
      return { ...initialState };
    default:
      return { ...state };
  }
};

function ViewCart({
  winesList = [],
  addToCart,
  cart,
  removeFromCart,
  placeOrder,
  clearCart,
}) {
  const [state, dispatch] = useReducer(reducer, initialState);



  const cartItems = winesList.filter((wine) =>
    Object.keys(cart).includes(wine.name)
  );

  

  const { getCount } = useCart();
  const cartsitemsall = useCart(cart);
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [showSucces, setShowSuccess] = useState(false)
  const [orderToken, setOrderToken] = useState(null);
  const [placingOrder, setPlacingOrder] = useState(false);
  const [mailSent, setMailSent] = useState(false);
  // const [totalQuantity, setTotalQuantity] = useState(0);

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    // console.log(value);
    
    const name = target.name;
    dispatch({
      type: Action_Type.handleInputChange,
      payload: { name, value },
    });
  };

  const validateForm = () => {
    let errors = state.errors;

    errors.name = state.name.length > 0 ? "" : "Please enter valid name.";
    errors.email = validateEmail(state.email)
      ? ""
      : "Please enter valid email.";
    errors.policy = state.policy ? "" : "Please accept the privacy policy."
    dispatch({
      type: Action_Type.handleError,
      payload: { errors: { ...errors } },
    });
  };

  const isValidForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
    return valid;
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (skipmail) => {
    
    try {
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: true },
      });
      if (!skipmail) {
      validateForm();
      if (!isValidForm(state.errors)) {
        dispatch({
          type: Action_Type.loading,
          payload: { isLoading: false },
        });
        return;
      }

      let successData = await handlePlacingOrder();
      

      
        await sendMail(successData);
      } else {
      await handlePlacingOrder();
      setOrderPlaced(true);
      setShowSuccess(true)
      setPlacingOrder(false);
        
      }
      
     

      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: false },
      });
    } catch (error) {
      let errors = state.errors;
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: false, errors: errors },
      });
    }
  };

  useEffect(() => {
    if (cart){
      setOrderToken({cart: cart})
    }
    
    
  },  [cart])

  const getTotalPrice = () => {
    let total = 0;
    Object.keys(cart).forEach((key) => {
      let priceStr = cart[key].retail;
      console.log(priceStr);
      

      if (!(priceStr == "LANDING SOON" || priceStr == "SOLD OUT")) {
        let priceInt = parseInt(priceStr);

      let quantityInt = parseInt(cart[key].count);
      console.log("toatal", total, priceStr);
      

      total += priceInt * quantityInt;
      } 

      
    });
    return total;
  };

  const handlePlacingOrder = async () => {
    setPlacingOrder(true);
    let success = { token: "", cart: {} };
    let obj = {
      name: state.name,
      email: state.email,
    };
    await placeOrder(obj, {
      successCallback: (token, cart) => {
        success.token = token;
        success.cart = cart;
        setOrderToken(success);
        
      },
    });
    return success;
  };

  const handleSkip = () => {
    setOrderPlaced(false)

     handleSubmit(true)
  
  }

  const sendMail = async (successData) => {  
  
    axios
      .post(sendEmailURL, {
        name: state.name,
        email: state.email,
        token: successData.token,
        cart: successData.cart,
        totalPrice: getTotalPrice(),
        totalQuantity:getCount(successData.cart)
      })
      .then((response) => {
        if (response.status === 200) {
          setOrderPlaced(true);
          setShowSuccess(true)
          setPlacingOrder(false);
        }
        // console.log(response);
      })
      .catch((error) => {
        setPlacingOrder(false)
        // setOrderPlaced(true);
        // setPlacingOrder(false);
        console.error(error);
      });
  };

  const handleNavigate = () => {
    navigate("/")
    dispatch({
      type: Action_Type.resetState,
      payload: {} ,
    });
    dispatch({
      type: Action_Type.handleError,
      payload: { errors: {} },
    });
  }

  const handleClose = (close) => {
    setOrderPlaced(false)
    setMailSent(false)
    close()
    setOrderToken({})
    dispatch({
      type: Action_Type.handleError,
      payload: { errors: {} },
    });

  }

                <div onClick={() => {setOrderPlaced(false); setMailSent(true)}} className={styles.checkoutBtn}>Submit</div>
  const handleClearCart = (close) => {
    
    clearCart()
    handleClose(close)
  }

  return (
    <Popup
      trigger={
        <button
          style={{
            background: "none",
            border: "none",
            color: "#fff",
          }}
        >
          <div
            className={styles.viewCartCard}
            style={{
              backgroundImage: `url(${btnBg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              width: "191px",
              height: "56px",
              cursor: "pointer",
            }}
          >
            View Cart
          </div>
        </button>
      }
      modal
    >
      {(close) => (
        <div className={styles.cartModal}>
          <div className={styles.modalHeader}>
            <div>{orderPlaced ? showSucces ? "Order placed" : "Your Cart" : mailSent ?  "Enter Your Details"  : "Your Cart"}</div>
            <div
              className={styles.closeIcon}
              onClick={() => (orderPlaced  && showSucces ? handleNavigate() : handleClose(close))}
            >
              <img src={require("../../assets/images/close.png")} />
            </div>
          </div>
          {orderPlaced ? showSucces ? <div className={styles.orderPlacedLast}><div>Your Order Has been placed Successfully</div></div> :  (
            <div className={styles.orderPlaced}>
              {/* <h3>Your Token Number</h3>
              <h1>{orderToken.token}</h1> */}
              {orderToken && (
                <div className={styles.orderTkn}>
                  {/* <div style={{maxHeight: "500px",
    overflow: "auto"}}> */}
                <table>
                  <thead>
                    <tr style={{ width: "100%" }} key="heading">
                      <th style={{ width: "60%", background: "#000" }}>
                        Product Name
                      </th>
                      <th style={{ width: "10%", background: "#000" }}>
                        Quantity
                      </th>
                      <th style={{ width: "30%", background: "#000" }}>
                        Retail
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    {Object.keys(orderToken.cart).map((key, index) => (
                      <tr key={index}>
                        <td>{key}</td>
                        <td>{cart[key].count}</td>
                        <td>{cart[key].retail}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot style={{ background: "#ffffff52" }}>
                    <tr>
                      <td>Total</td>
                      <td>{orderToken ? getCount(orderToken.cart) : 0}</td>
                      <td>
                        {orderToken && getTotalPrice(orderToken.cart) === 0 ? ""  :`THB ${getTotalPrice(orderToken.cart)} with VAT` }
                        
                      </td>
                    </tr>
                  </tfoot>
                </table>
                {/* </div> */}
                <div className={styles.btnWrapper}>
                <div onClick={() => {setOrderPlaced(false); setMailSent(true)}} className={styles.checkoutBtn}>Submit</div>
              
               
                </div>
                
                </div>
              )}
              {/* <h4>
                Please show this order token to get your order. Do not misplace
                this token until you pick your order. You cannot retrieve the
                token number again. Please place new order in case the token
                number is lost.
              </h4> */}
            </div>
          ) : (
            <div className={styles.cartItems}>
              {mailSent ? (
                <div className={styles.cart}>
                  {inputs.map((input, index) => {
                    if (input.name === "policy") {
                      return (
                        <>
                        <div className={styles.checkBoxWrapper}>
                          <input name={input.name} type="checkbox" required onChange={(e) => handleInputChange(e)} className={styles.customCheckBox}/>
                          <div>{input.label} <a href="http://www.africau.edu/images/default/sample.pdf" rel="noreferrer" target="_blank" style={{ textDecoration: "none", color: "#b12535"}}>Terms of Use and Privacy Policy.</a></div>
                        </div>
                        {state.errors[input.name] && (
                          <div style={{ marginTop: "0.5rem"}} className="error">
                            {state.errors[input.name]}
                          </div>
                        )}
                        </>
                      )
                    } else {
                      return (
                        <div key={index}>
                      <label htmlFor={input.name}>{input.label}</label>
                      <div key={input.name} className={styles.inputGroup}>
                        <input
                          id={input.name}
                          name={input.name}
                          className={input.className}
                          type={input.type}
                          placeholder={input.placeholder}
                          value={state[input.name]}
                          required={input.required}
                          onChange={(e) => handleInputChange(e)}
                        />
                        {state.errors[input.name] && (
                          <div className="error">
                            {state.errors[input.name]}
                          </div>
                        )}
                      </div>
                    </div>
                      )
                    }
                    
                    
                  })}
                </div>
              ) : (
                cartItems.map((item, index) => {
                  const { imgUrl, name, subtitle, retail } = item;
                  if (cart[name]) {
                    return (
                      <div key={index} className={styles.cartItem}>
                        <div className={styles.left}>
                          <img
                            src={imgUrl}
                            alt={name}
                            className={styles.image}
                          />
                          <div className={styles.details}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.subtitle}>{subtitle}</div>
                          </div>
                        </div>
                        <div className={styles.cartActions}>
                          <div onClick={() => removeFromCart(name)}>-</div>
                          <div className={styles.count}>{cart[name].count}</div>
                          <div onClick={() => addToCart(name, retail)}>+</div>
                        </div>
                      </div>
                    );
                  }
                  return;
                })
              )}
            </div>
          )}
          {!orderPlaced && (
            <div
              style={{
                pointerEvents: placingOrder ? "none" : "all",
                opacity: placingOrder ? 0.5 : 1,
              }}
              className={styles.checkout}
             
            >
              <div className={styles.btnWrapper}>
              <div  onClick={() => {
                if (!mailSent) {
                  setOrderPlaced(true);
                  
                } else {
                  handleSubmit();
                }
              }} className={styles.checkoutBtn}>
                {placingOrder
                  ? "Placing Order"
                  : mailSent
                  ? "Submit"
                  : "Checkout"}
              </div>
              {mailSent ? <div onClick={() => handleSkip()} className={styles.checkoutBtn}>Skip</div> :  <div onClick={() => handleClearCart(close)} className={styles.checkoutBtn}>Clear Cart</div>}
              </div>
            </div>
          )}
        </div>
      )}
    </Popup>
  );
}

export default ViewCart;
